import styled from 'styled-components'

const StyledMediaItem = styled.div`
    width: calc(33% - 1rem);
    margin: 0 0.5rem;
    margin-bottom: 1.5rem;
`

export default StyledMediaItem